import { CheckoutPresenter } from '@Screens/Checkout/presenter';
import { ObservableProp, useClassStore } from '@Utils/useClassStore';
import { inject, injectable } from 'inversify';
import { action } from 'mobx';

import container from '~ioc/ioc';
import { ProductPanelMarkers } from '~types/views-types';

@injectable()
class ProductDescriptionPresenter {
  @inject(CheckoutPresenter) private _checkoutPresenter!: CheckoutPresenter;

  detailsVisible = new ObservableProp(false);
  @action onTogglePress = () => {
    this.detailsVisible.set(!this.detailsVisible.value);

    if (this.detailsVisible.value) {
      this._checkoutPresenter.scrollViewManager
        .scrollToId(ProductPanelMarkers.ProductDescription)
        .then();
    }
  };
}

export const useProductDescriptionPresenter = () =>
  useClassStore<ProductDescriptionPresenter>(
    container.get(ProductDescriptionPresenter)
  );
